import NotificationDocumentTypeId from "../enums/NotificationDocumentTypeIds";

export default interface NotificationTemplateFormatOption {
    id: number;
    label: string;
}

export const notificationTemplateFormats: NotificationTemplateFormatOption[] = [
    { id: NotificationDocumentTypeId.Pdf, label: "Attachment" },
    { id: NotificationDocumentTypeId.Png, label: "Embedded" }
]